import React from "react";
import { Row, Col } from "react-bootstrap";
import MetricCard from "./MetricCard";

// Phase 5, §11/§30. Raw task-accountability numbers — always shown, even
// with no performance profile configured (§1: "raw metrics before
// composite score").
export default function WorkloadSummary({ accountability }) {
  const a = accountability || {};
  return (
    <Row className="g-3">
      <Col xs={6} md={3}><MetricCard label="Tasks Assigned" value={a.tasksAssigned} direction="INFORMATIONAL_ONLY" icon="fa-list-check" /></Col>
      <Col xs={6} md={3}><MetricCard label="Tasks Completed" value={a.tasksCompleted} direction="HIGHER_IS_BETTER" icon="fa-circle-check" /></Col>
      <Col xs={6} md={3}><MetricCard label="Tasks Open" value={a.tasksOpen} direction="INFORMATIONAL_ONLY" icon="fa-folder-open" accent="warning" /></Col>
      <Col xs={6} md={3}><MetricCard label="Tasks Overdue" value={a.tasksOverdue} direction="LOWER_IS_BETTER" icon="fa-triangle-exclamation" /></Col>
    </Row>
  );
}
